// What Today still wants from you, shared by the Today screen and the nav
// badge (29 Jul 2026) so the two can never disagree: one derivation, two
// readers. Frequency-aware in the same way the check-list is, via the
// parsed cadence.
import { weeklyTarget } from "../../shared/cadence.js";
import type { StatePayload } from "./types.js";

// Due today: every active practice that has not yet met its cadence for the
// week, plus anything already ticked today (a ticked row still belongs to
// the day). Unscheduled kinds rest until ticked, exactly as on screen.
export function dueToday(s: StatePayload): StatePayload["plan"] {
  return s.plan.filter((p) => {
    if (p.status !== "active") return false;
    const target = weeklyTarget(s.cards[p.cardId]?.cadence);
    return p.week.includes(s.today) || p.week.length < target;
  });
}

// The nav badge: what is left to do plus what is left to decide. Zero means
// the day is answered, and the badge renders blank rather than "0".
export function todayOpenCount(s: StatePayload): number {
  const left = dueToday(s).filter((p) => !p.week.includes(s.today)).length;
  const undecided = s.todayNew.filter((slot) => slot.state === "new").length;
  return left + undecided;
}
